var _defs, _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompoundLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#e2e2e2;}.cls-3{fill:#c1c1c1;}.cls-4{fill:#1b94ff;}.cls-5{fill:#1a94ff;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    width: 500,
    height: 500
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m158.44,103.01h184.17c11.81,0,21.39,9.21,21.39,20.56v249.4c0,11.36-9.58,20.56-21.39,20.56h-184.17c-11.81,0-21.39-9.21-21.39-20.56V123.57c0-11.36,9.58-20.56,21.39-20.56Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m170.24,128.96h160.57c4.07,0,7.36,3.86,7.36,8.62v14.9c0,4.76-3.3,8.62-7.36,8.62h-160.57c-4.07,0-7.36-3.86-7.36-8.62v-14.9c0-4.76,3.3-8.62,7.36-8.62Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m170.24,177.49h160.57c4.07,0,7.36,3.86,7.36,8.62v14.9c0,4.76-3.3,8.62-7.36,8.62h-160.57c-4.07,0-7.36-3.86-7.36-8.62v-14.9c0-4.76,3.3-8.62,7.36-8.62Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m170.24,274.55h160.57c4.07,0,7.36,3.86,7.36,8.62v14.9c0,4.76-3.3,8.62-7.36,8.62h-160.57c-4.07,0-7.36-3.86-7.36-8.62v-14.9c0-4.76,3.3-8.62,7.36-8.62Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m170.24,323.08h160.57c4.07,0,7.36,3.86,7.36,8.62v27.26c0,4.76-3.3,8.62-7.36,8.62h-160.57c-4.07,0-7.36-3.86-7.36-8.62v-27.26c0-4.76,3.3-8.62,7.36-8.62Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m263.17,226.02h67.64c4.07,0,7.36,3.86,7.36,8.62v14.9c0,4.76-3.3,8.62-7.36,8.62h-67.64c-4.07,0-7.36-3.86-7.36-8.62v-14.9c0-4.76,3.3-8.62,7.36-8.62Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m170.24,226.02h67.64c4.07,0,7.36,3.86,7.36,8.62v14.9c0,4.76-3.3,8.62-7.36,8.62h-67.64c-4.07,0-7.36-3.86-7.36-8.62v-14.9c0-4.76,3.3-8.62,7.36-8.62Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompoundLight);
export default __webpack_public_path__ + "static/media/Compound_Light.6af8ac3e486815adde92988e23e04e99.svg";
export { ForwardRef as ReactComponent };